module.exports = __webpack_public_path__ + "media/images/donation/how-to-use1-afcfcd4d188121d0d28a7a80254fc1ed.jpg";